'use client';
import React from 'react';

import Script from 'next/script';

import { isDevelopment } from '@/modules/env/isDevelopment';

type Props = {
  id: string;
  nonce: string;
};

export function InitGTM({ id, nonce }: Props) {
  if (typeof window === 'undefined') {
    return null;
  }

  // JR 28/05/26: '/vwdj' refers to a path we have configured in cloudflare to enable
  // Google Tag Manager to load on both staging and production, both of these values
  // must match in order for this script to work as expected.

  // DS 30/06/26: the change referenced in the above comment broke GTM debugging
  // in dev. The const below fixes that by allowing us to still use the old url to load GTM
  // directly
  const gtmSrc = isDevelopment()
    ? 'https://www.googletagmanager.com/gtm.js?id='
    : '/vwdj/?id=';

  // eslint-disable-next-line react-hooks/immutability
  window.dataLayer = window.dataLayer || [];
  return (
    <Script id="gtm" strategy="lazyOnload" nonce={nonce}>
      {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '${gtmSrc}'+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${id}');`}
    </Script>
  );
}
